import styled from "@emotion/styled";
import theme from "@theme";

const Requestform = styled.div`
  margin-top: 5px;
  display: flex;
  width: 70%;
  height: 75%;
  flex-direction: column;

  @media (max-width: 768px) {
    width: 70%;
    margin: 5px;
    // height: auto;
  }
`;

const RequestHeading = styled.p`
  font-family: Roboto;
  font-size: 2rem;
  font-weight: bold;
  text-align: center;
  color: #565656;
  width: 100%;
  margin-top: 0;
`;

const messagedetails = styled.div`
  width: 40%;
  font-weight: 700;
  margin-top: -10px;
`;

const Reqdetails = styled.p`
  width: 100%;
  margin: 4px 0px 4px 0px;
  padding: 0;
  color: #979797;
  font-size: 12px;
  font-weight: 300;
  display: flex;
`;

const Form = styled.form`
  /* Any specific styles for form can be added here if needed */
`;

const Label = styled.label`
  color: ${theme.colors.black};
  width: 20%;
  font-family: Roboto;
  font-size: 13px;
  font-weight: bold;
  line-height: 19px;
`;

const ReqButton = styled.button`
  width: 100%;
  border: none;
  background: ${theme.gradient.themeGradient};
  color: ${theme.colors.white};
  font-size: 12px;
  cursor: pointer;
  border-radius: 8px;
  height: 35px;
  text-align: center;
  gap: 10px;
`;

const BackButton = styled.div`
  width: 100%;
  border: none;
  font-size: 12px;
  cursor: pointer;
  border-radius: 8px;
  height: 35px;
  text-align: center;
`;

const RequestAccessButton = styled.div`
  width: 100%;
  border: none;
  font-size: 12px;
  cursor: pointer;
  border-radius: 8px;
  margin: 16px 0px 25px 0px;
  height: 35px;
  text-align: center;
  align-items: center;
`;
const LabelContainer = styled.div`
  display: flex;
  margin-top: 20px;
`;

const Form2 = styled.form``;
const DivC = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 2.5rem;
  row-gap: 0;

  @media (max-width: 768px) {
    grid-template-columns: 1fr; /* stack items on small screens */
  }
`;

const FormGroup = styled.div`
  margin-top: 1rem;
  &.full-width {
    grid-column: 1 / -1;
  }
`;

const Label2 = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  color: #4a5568;
  font-weight: 500;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid ${theme.colors.bordertask};
  border-radius: 6px;
  font-size: 1rem;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
  }
`;

const Astrik = styled.span`
  color: red;
`;

const ValidtionMessages = styled.p`
  color: gray;
  font-size: 10px;
  padding-block: 0px;
  margin-block: 0px;
`;

const StyledTextArea = styled.textarea`
  height: 60px;
  font-size: 16px;
  width: 100%;
  border: 1px solid ${theme.colors.bordertask};
  border-radius: 6px;
  min-height: 60px;
  padding: 0.5rem;

  &:focus {
    outline: none;
    border: 1px solid ${theme.colors.themecolor}; // Change to your theme color
  }
`;

const imagecontainer = styled.img`
  width: 200px;
  height: 60px;
  margin: 0px 0px 10px 0px;
  object-fit: contain;
`;

const SC = {
  Requestform,
  RequestHeading,
  messagedetails,
  Reqdetails,
  Form,
  Label,
  ReqButton,
  BackButton,
  RequestAccessButton,
  LabelContainer,
  Form2,
  FormGroup,
  Label2,
  Input,
  Astrik,
  ValidtionMessages,
  StyledTextArea,
  DivC,
  imagecontainer,
};

export default SC;
